import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "error"]

  fieldValue(name) {
    return this.element.querySelector(`[name="${name}"]`)?.value || undefined
  }

  async submit(event) {
    event.preventDefault()
    const email = this.fieldValue("email")
    const first_name = this.fieldValue("first_name")
    const last_name = this.fieldValue("last_name")
    this.submitTarget.disabled = true

    const response = await fetch("https://api.bukazu.com/graphql", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: `mutation createUser($email: String!, $first_name: String, $last_name: String) {
          createUser(is_trial: true, email: $email, first_name: $first_name, last_name: $last_name) { id }
        }`,
        variables: { email, first_name, last_name }
      })
    })

    const result = await response.json()

    if (result.errors) {
      this.errorTarget.hidden = false
      this.submitTarget.disabled = false
    } else {
      window.location = "/bedankt-voor-uw-aanmelding"
    }
  }
}
